/**
 * MobileTabBar
 * Version-gated: v2 renders the classic 4+More mobile tab bar,
 * v3 renders the 6-tab Excel worksheet BottomSheetTabs.
 *
 * v2: Visible only on viewports below the md breakpoint.
 * v3: Visible on all viewports (desktop 34px, mobile 40px).
 */

import { isV3 } from '../../hooks/useDesignVersion';
import { MobileTabBarV2 } from './MobileTabBarV2';
import { BottomSheetTabs } from './BottomSheetTabs';

export function MobileTabBar() {
  if (isV3()) {
    return <BottomSheetTabs />;
  }
  return <MobileTabBarV2 />;
}
